<template>
  <div class="apply-step apply-step--terminal">
    <div class="apply-step__icon">✅</div>
    <h2>Ya eres parte de GoGuau</h2>
    <p>Tu cuenta de paseador ya está activa.</p>
    <p>Descarga la app de paseador para empezar a recibir paseos:</p>
    <div class="apply-actions" style="justify-content: center; flex-wrap: wrap;">
      <a class="btn btn-warning" href="https://play.google.com/store/apps/details?id=com.goguau" target="_blank">
        Descargar app
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ResultApproved',
  mounted() { this.clearAll() },
  methods: { ...mapActions('apply', ['clearAll']) },
}
</script>

<style src="../apply-step.css" scoped></style>
<style scoped>
.apply-step--terminal { text-align: center; padding: 2rem 1rem; }
.apply-step__icon { font-size: 4rem; margin-bottom: 1rem; }
</style>
